import { useEffect } from 'react';
import Container from '../../components/layouts/Container/Container';
import PageWrapper from '../../components/layouts/PageWrapper/PageWrapper';
import { SubheaderLeft } from '../../components/layouts/Subheader/Subheader';
import SimpleLoader from '../../components/ui/SimpleLoader';
import { useAuth } from '../../context/authContext';
import { subscriptionList } from '../../services/apiService';
import SubscriptionProduct from './_partial/SubscriptionProduct.partial';

const SubscriptionPage = () => {
	const { response, error, loading, call } = subscriptionList();
	const { onLogout } = useAuth();
	useEffect(() => {
		call().subscribe({
			error: (error) => {
				if (error?.status === 409) {
					onLogout(error?.status);
				}
				console.error('An error occurred:', error);
			},
		});
	}, []);

	return (
		<>
			<PageWrapper name='Dashboard' checkDuplicate>
				<SubheaderLeft>
					<div className='mt-4 flex-col gap-4 pb-2 ps-5'>
						<span className='text-sm text-gray-600'>Plan</span>
						<p className='mb-0 text-xl font-semibold'>Subscription</p>
					</div>
				</SubheaderLeft>
				<Container>
					<div className='mb-6'>
						<h2 className='text-2xl font-bold text-gray-800 mb-3'>Choose Your Plan</h2>
						<p className='text-gray-600'>Select the subscription that best fits your needs</p>
					</div>
					<div className='mb-14 grid grid-cols-1 gap-4'>
						{loading && <SimpleLoader />}
						{/* {error && <div>Error: {error.message}</div>} */}
						{response && response.data && response.data.subscriptionList && (
							<>
								{response.data.subscriptionList.length > 0 ? (
									<>
										<div className='max-4 grid gap-6 md:grid-cols-2 lg:grid-cols-4'>
											{response.data.subscriptionList.map(
												(subscription: any) => (
													<SubscriptionProduct
														key={subscription.id}
														title={subscription.name}
														description={subscription.description}
														showSubscribeButton={true}
														price={subscription.price}
														priceId={subscription.id}
														duration={subscription.duration}
														className='mb-4'
													/>
												),
											)}
										</div>
										<div className='mt-8 p-4 bg-gray-50 rounded-lg border border-gray-200'>
											<h3 className='text-lg font-semibold mb-2'>Need Help Choosing?</h3>
											<p className='text-gray-600'>
												Contact our support team for personalized guidance on selecting the right plan for your needs.
											</p>
										</div>
									</>
								) : (
									<div className='p-8 text-center bg-gray-50 rounded-lg border border-gray-200'>
										<h3 className='text-xl font-semibold mb-2'>No Subscriptions Available</h3>
										<p className='text-gray-600'>Please check back later for available subscription plans.</p>
									</div>
								)}
							</>
						)}
					</div>
				</Container>
			</PageWrapper>
		</>
	);
};

export default SubscriptionPage;
